import React from 'react';
import { Input } from '../common/Input';

interface ProjectNameInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const ProjectNameInput: React.FC<ProjectNameInputProps> = ({
  value,
  onChange,
  error,
}) => {
  return (
    <Input
      label="Project Name"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="My Awesome Game"
      error={error}
      autoFocus
      maxLength={50}
    />
  );
};
